import { Component, OnInit, Inject, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LlamadasBitacoraComponent } from '../llamadas-bitacora/llamadas-bitacora.component';
import { HistorialReprogComponent } from '../historial-reprog/historial-reprog.component';

@Component({
  selector: 'app-historial-cobros',
  templateUrl: './historial-cobros.component.html',
  styleUrls: ['./historial-cobros.component.scss']
})
export class HistorialCobrosComponent implements OnInit, AfterViewInit, OnDestroy {

  /**
   * DataTable
   */
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  /**
   * Constructor
   *
   * @param _data
   * @param {CarteraService} _cartera
   * @param {MatDialog} dialog
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data,
    private _cartera: CarteraService,
    private dialog: MatDialog
  )
  {
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.dtOptions = {
      order: [0, 'desc'],
      scrollY: '383px',
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          data: 'FechaCobro'
        },
        {
          data: 'usuario_creador'
        },
        {
          data: 'reprogramdor'
        },
        {
          data: 'ActividadCobro'
        },
        {
          data: 'estado_cobro'
        },
        {
          data: 'ObservacionesCobro'
        },
        {
          render: (data, type, row, meta) => {
            return `<a>${data}</a>`;
          }
        },
        {
          data: 'NFactura'
        },
        {
          data: 'ValorCobro'
        },
        {
          data: 'MesAPagar'
        },
        {
          data: 'AnioAPagar'
        },
        {
          data: 'cobrador'
        },
        {
          render: (data, type, row, meta) => {
            return `<a>${data}</a>`;
          }
        },
        {
          data: 'tipo_reprogramacion'
        },
        {
          data: 'ReprogramacionFecha'
        },
        {
          data: 'jornada'
        },
        {
          data: 'hora_cobro'
        },
        {
          data: 'DirAlternativa'
        },
        {
          data: 'NotasOtros'
        }
      ],
      responsive: true
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit(): void{
    if(this._data.cobros === undefined){
      this._cartera.VerHistorialCobros(this._data.grunit, this._data.grugru).subscribe((data: any) => {
        this.tableOpt = data;
        this.renderer();
      });
    }else{
      this.tableOpt = this._data.cobros;
    }
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // ----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  /**
   * Abre modal LlamadasBitacora, encargado de mostrar el historial de llamadas que posee una factura
   * @param {string} id_grupo
   * @param {string} factura
   */
  modalHistorialLlamadasxFact(id_grupo: string, factura: string): void{
    this.dialog.open(LlamadasBitacoraComponent, {
      data: {
        id_grupo: id_grupo,
        factura: factura
      }
    });
  }

  /**
   * Abre modal HistorialReprog, encargado de mostrar el historial de reprogramaciones de un cobro
   * @param {string} ID_cobro
   */
  modalHistorialReprogramacion(ID_cobro: string): void {
    this.dialog.open(HistorialReprogComponent, {
      data: {
        cobro: ID_cobro
      }
    });
  }
}
